<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'Spinner',
    props: {
      size: {
        type: String,
        default: '1em',
      },
      thickness: {
        type: String,
        default: '2px',
      },
    },
  })
</script>

<template>
  <span
    class="spinner"
    :style="{ width: size, height: size, borderWidth: thickness }"
    aria-hidden="true"
  ></span>
</template>

<style lang="scss" scoped>
  @use '@/variables' as *;

  @keyframes spinner-spin {
    to {
      transform: rotate(360deg);
    }
  }

  .spinner {
    display: inline-block;
    vertical-align: top;
    border-style: solid;
    border-color: currentColor;
    border-top-color: transparent;
    border-radius: $radius-circle;
    animation: spinner-spin 600ms linear infinite;
  }
</style>
